module.exports = __webpack_public_path__ + "media/images/dolby_vision_black-c54de3fde115940210cf368cf72602a0.png";